import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  isValidChassie,
} from '@/utils';

import {
  mapMutations,
} from 'vuex';

export default {
  name: 'InputChassie',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    name: '',
    label: '',
    property: '',
    modelState: '',
    rules: '',
    disabled: false,
    placeholder: '',
    mask: '',
  },
  data: () => ({
    changed: false,
    error: false,
  }),
  computed: {
    model: {
      get() {
        return this.modelState;
      },
      set(newModel) {
        this.SET_CHASSIE(newModel);

        this.error = newModel !== '' && !isValidChassie(newModel);

        return newModel;
      },
    },
    showMask() {
      return this.changed && (typeof this.mask !== 'undefined');
    },
  },
  methods: {
    ...mapMutations('appointment', {
      SET_CHASSIE: 'SET_CHASSIE',
    }),
    triggerChange() {
      this.changed = true;
    },
  },
};
